export interface DisplayZone {
  zoneName?: string | null
  utcOffset?: string | null
}

const offsetToMinutes = (offset?: string | null) => {
  const m = /^([+-])(\d{2}):(\d{2})$/.exec(offset || '')
  if (!m) return 0
  return (m[1] === '-' ? -1 : 1) * (Number(m[2]) * 60 + Number(m[3]))
}

// Format in the user's zone when we know its IANA name; otherwise shift by the
// raw offset and format as UTC (Intl doesn't accept "+05:00" everywhere).
// `zone === null` means the admin's own browser timezone.
export const formatIn = (iso: string, zone: DisplayZone | null, opts: Intl.DateTimeFormatOptions) => {
  const date = new Date(iso)
  if (!zone) return new Intl.DateTimeFormat('en-US', opts).format(date)
  if (zone.zoneName) {
    try {
      return new Intl.DateTimeFormat('en-US', { ...opts, timeZone: zone.zoneName }).format(date)
    } catch (e) {
      // invalid zone name — fall through to the offset
    }
  }
  const shifted = new Date(date.getTime() + offsetToMinutes(zone.utcOffset) * 60000)
  return new Intl.DateTimeFormat('en-US', { ...opts, timeZone: 'UTC' }).format(shifted)
}

export const formatTime = (iso: string, zone: DisplayZone | null) =>
  formatIn(iso, zone, { hour: 'numeric', minute: '2-digit', hour12: true })

export const formatShortDay = (iso: string, zone: DisplayZone | null) =>
  formatIn(iso, zone, { weekday: 'short', month: 'short', day: 'numeric' })

export const zoneLabel = (zone?: DisplayZone | null) => zone?.zoneName || `UTC${zone?.utcOffset || '+00:00'}`

export const providerLabel: Record<string, string> = {
  google: 'Google Calendar',
  outlook: 'Outlook Calendar',
  apple: 'Apple (iCloud) Calendar',
  viveka: 'Viveka session',
}

export const sourceColor: Record<string, string> = {
  google: 'blue',
  outlook: 'indigo',
  apple: 'gray',
  viveka: 'teal',
}
